const academicLevelOptions = [
  {
    label: "Bac +1",
    value: "Bac +1"
  },
  {
    label: "Bac +2",
    value: "Bac +2"
  },
  {
    label: "Bac +3",
    value: "Bac +3"
  },
  {
    label: "Bac +4",
    value: "Bac +4"
  },
  {
    label: "Bac +5 ou +",
    value: "Bac +5 ou +"
  }
]

export { academicLevelOptions }
